import Badge from '@/components/common/badge';
import DateDisplay from '@/components/common/date-display';
import type { ConversationSessionsTypeUnion } from '@/models/conversations/conversation-session';

type Props = {
  session: ConversationSessionsTypeUnion;
};

export default function SessionListItemTime({ session }: Props) {
  let count = 0;
  if (session.IsNewSession) count = 1;
  if (session.UnReadCount > 0) count = session.UnReadCount;
  if (session.SessionType === 'group') count += session.GroupJoinApplyCount;

  return (
    <div className='flex flex-col items-end justify-between gap-2'>
      <DateDisplay
        timestamp={session.LastMsgTimeStamp}
        ruleName='session'
        className='whitespace-nowrap text-[0.75rem] text-secondary'
      />

      <Badge
        className='py-0.5 ring-0 mb-1'
        show={count > 0}>
        {session.IsNotDisturb ? '' : count > 99 ? '99+' : count}
      </Badge>
    </div>
  );
}
